import { render } from "./KontakInvestor.vue?vue&type=template&id=27cc2a82"
import script from "./KontakInvestor.vue?vue&type=script&lang=js"
export * from "./KontakInvestor.vue?vue&type=script&lang=js"

import exportComponent from "D:\\helmi\\blitarenergi\\vue\\companyprofile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__